import isEqual from 'lodash/isEqual';
import PropTypes from 'prop-types';
import React from 'react';
import ExpandableRow from './ExpandableRow';
import TableError from '../../modules/DataTable/components/TableError';

/**
 * Body of the table with expandable rows
 *
 * @param {{}} props
 * @constructor
 */
const ExpandableRowsBody = props => (
    <tbody>
        {(() => {
            if (!props.children.length > 0) {
                return (
                    <TableError
                        size={props.columns.length}
                        colSpanGetter={props.colSpanGetter}
                    >
                        {props.errorMessage}
                    </TableError>
                );
            }

            const rows = [];
            props.children.forEach((row, index) => {
                const expandedRow = props.expandedRow;
                const rowKey = props.identity ? props.identity(row) : row[props.primaryColumn];
                const isActive = expandedRow
                && expandedRow.findIndex(item => isEqual(item, rowKey)) !== -1;
                const isSelected = !!~props.selectedRows.findIndex(selectedRow =>
                    selectedRow === row);

                rows.push(
                    <ExpandableRow
                        key={index}
                        index={rowKey}
                        columns={props.columns}
                        onRowExpand={props.onRowExpand}
                        onRowSelect={props.onRowSelect}
                        isSelected={isSelected}
                        isActive={isActive}
                        evenClass={(index % 2 === 0) ? 'odd' : 'even'}
                    >
                        {row}
                    </ExpandableRow>
            );

                if (isActive) {
                    const ExpansionRow = props.expansionComponent;
                    rows.push(
                        <ExpansionRow
                            key={`${index}_exp`}
                            data={row}
                            size={props.columns.length}
                            scrollToRow={props.scrollToRow}
                            colSpanGetter={props.colSpanGetter}
                        />
                );
                }
            });

            return rows;
        })()}
    </tbody>
);

ExpandableRowsBody.propTypes = {
    /**
     * Component which should be rendered in expanded row
     */
    expansionComponent: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.func,
    ]).isRequired,
    /**
     * Data array representing rows
     */
    children: PropTypes.array,
    /**
     * List of table columns
     */
    columns: PropTypes.array,
    /**
     * List of table selected rows
     */
    rows: PropTypes.array,
    /**
     * List of table selected rows
     */
    selectedRows: PropTypes.array,
    /**
     * Unique values column used as ID to expand/collapse
     */
    primaryColumn: PropTypes.string,
    /**
     * Identity function for cases when the primary key is complex
     */
    identity: PropTypes.func,
    /**
     * Error message if no data was found
     */
    errorMessage: PropTypes.string,
    /**
     * On row click event handler
     */
    onRowExpand: PropTypes.func,
    /**
     * On row select event handler
     */
    onRowSelect: PropTypes.func,
    /**
     * Primary column value to mark expanded row
     */
    expandedRow: PropTypes.any,
    /**
     * Primary column value to scroll to expanded row
     */
    scrollToRow: PropTypes.any,
    /**
     * Callback, that returns amount of columns should be collapsed
     */
    colSpanGetter: PropTypes.func
};

export default ExpandableRowsBody;



// WEBPACK FOOTER //
// ./src/js/components/DataTable/ExpandableRowsBody.js